import { Injectable, Injector, ReflectiveInjector } from '@angular/core';
import { } from '@angular/common';
import { Http, BrowserXhr, ConnectionBackend, XHRBackend, Headers, BaseResponseOptions, BaseRequestOptions, CookieXSRFStrategy, XSRFStrategy, RequestOptions, ResponseOptions } from '@angular/http';
import { AbstractControl, FormGroup, FormControl, FormArray, ValidatorFn } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../../environments/environment';
import { UtilService } from './util.service';


@Injectable()
export class ValidationService {
  email_regexPattern  = '[a-zA-Z0-9.-_]{1,}@[a-zA-Z.-]{2,}[.]{1}[a-zA-Z]{2,}';
  password_regexPattern  = '^(?=.*?[A-Z])(?=.*?[#?!@$%^&*-]).{8,}$';
  password_Pattern = '^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$';
  phoneNumber_regexPattern  = '^[0-9]*$';
  webUrl_regexPattern  = 'https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9]\.[^\s]{2,}';
  isNumber_regexPattern  = '[0-9]*$';
  hasNoLeadingSpaces = '^[^\s][A-Za-z0-9\s]*[^\s]$';
  specialAlphaNumeric = '^[a-zA-Z0-9\-_]*$';

  constructor(
    private utilService: UtilService

  ) { }
  minLengthArray(min: number) {
    return (c: AbstractControl): { [key: string]: any } => {
      if (c.value.length >= min)
        return null;
      return { 'minLengthArray': { valid: false } };
    }
  }

  noWhitespaceValidator(control: FormControl) {
    let isWhitespace = (control.value || '').trim().length === 0;
    let isValid = !isWhitespace;
    return isValid ? null : { 'whitespace': true }
  }


  maxLength(max: number) {
    return (c: AbstractControl): { [key: string]: boolean } => {
      if (c.value && c.value.toString().length > max) {
        return { 'maxlength': true };
      }
      return null;
    };
  }

  validateRange(c: any) {
    const rangeNotMatch: any = { rangeNotMatch: true };
    let find: boolean = false;
    if (c && c.value && c.value.length) {
      // throw new TypeError('Seasons length must be a greater than 1');    
      c.controls.forEach(x => {
        if (x.errors && x.errors['rangeNotMatch']) {
          delete x.errors['rangeNotMatch'];
          if ((x.errors === null || typeof (x.errors) === 'undefined') || (x.errors && x.errors.constructor === Object && Object.keys(x.errors).length === 0) ||
            x.errors.toString().trim() === '') {
            x.setErrors(null);
          }
        }
      });
      for (let i = 0; i < c.value.length; i += 1) {
        if ((c.value[i].minRange != null || c.value[i].minRange !== '') && (c.value[i].maxRange != null || c.value[i].maxRange !== '')) {
          // let isDateRangeOverlaps = this.utilService.dateRangeOverlaps(new Date(c.value[i].startDate.formatted), new Date(c.value[i].endDate.formatted), new Date(c.value[j].startDate.formatted), new Date(c.value[j].endDate.formatted));
          if (parseInt(c.value[i].minRange) >= parseInt(c.value[i].maxRange)) {
            c.controls[i].get('maxRange').setErrors(rangeNotMatch);
            find = true;
            // return datesOverlapped;
          }
        }
      }
      if (find) {
        return rangeNotMatch;
      }
      return null;
    }
  }


  checkKitType(c: any) {
    const kitMissMatch: any = { kitMissMatch: true };
    let find: boolean = false;
    if (c && c.value && c.value.length > 1) {
      // throw new TypeError('Seasons length must be a greater than 1');    
      c.controls.forEach(x => {
        if (x.errors && x.errors['kitMissMatch']) {
          delete x.errors['kitMissMatch'];
          if ((x.errors === null || typeof (x.errors) === 'undefined') || (x.errors && x.errors.constructor === Object && Object.keys(x.errors).length === 0) ||
            x.errors.toString().trim() === '') {
            x.setErrors(null);
          }
        }
      });
      for (let i = 0; i < c.value.length - 1; i += 1) {
        for (let j = i + 1; j < c.value.length; j += 1) {
          if (c.value[i].kitId && c.value[i].discountType && c.value[j].kitId && c.value[j].discountType) {
            // let isDateRangeOverlaps = this.utilService.dateRangeOverlaps(new Date(c.value[i].startDate.formatted), new Date(c.value[i].endDate.formatted), new Date(c.value[j].startDate.formatted), new Date(c.value[j].endDate.formatted));
            if (c.value[i].kitId == c.value[j].kitId && c.value[i].discountType == c.value[j].discountType) {
              c.controls[i].setErrors(kitMissMatch);
              c.controls[j].setErrors(kitMissMatch);
              find = true;
              // return datesOverlapped;
            }
          }
        }
      }
      if (find) {
        return kitMissMatch;
      }
      return null;
    }
  }

  checkAbtKitType(c: any) {
    const kitMissMatch: any = { kitMissMatch: true };
    let find: boolean = false;
    if (c && c.value && c.value.length > 1) {
      // throw new TypeError('Seasons length must be a greater than 1');    
      c.controls.forEach(x => {
        if (x.errors && x.errors['kitMissMatch']) {
          delete x.errors['kitMissMatch'];
          if ((x.errors === null || typeof (x.errors) === 'undefined') || (x.errors && x.errors.constructor === Object && Object.keys(x.errors).length === 0) ||
            x.errors.toString().trim() === '') {
            x.setErrors(null);
          }
        }
      });
      for (let i = 0; i < c.value.length - 1; i += 1) {
        for (let j = i + 1; j < c.value.length; j += 1) {
          if (c.value[i].kitId && c.value[j].kitId) {
            if (c.value[i].kitId == c.value[j].kitId) {
              c.controls[i].setErrors(kitMissMatch);
              c.controls[j].setErrors(kitMissMatch);
              find = true;
            }
          }
        }
      }
      if (find) {
        return kitMissMatch;
      }
      return null;
    }
  }

  checkRange(c: any) {
    const rangeMissMatch: any = { rangeMissMatch: true };
    let find = false;
    if (c && c.value && c.value.length > 1) {
      // throw new TypeError('Seasons length must be a greater than 1');    
      c.controls.forEach(x => {
        if (x.errors && x.errors['rangeMissMatch']) {
          delete x.errors['rangeMissMatch'];
          if ((x.errors === null || typeof (x.errors) === 'undefined') || (x.errors && x.errors.constructor === Object && Object.keys(x.errors).length === 0) ||
            x.errors.toString().trim() === '') {
            x.setErrors(null);
          }
        }
      });
      for (let i = 0; i < c.value.length - 1; i += 1) {
        for (let j = i + 1; j < c.value.length; j += 1) {
          if (c.value[i].minRange && c.value[i].maxRange && c.value[j].minRange) {
            let a = parseInt(c.value[i].maxRange);
            let b = parseInt(c.value[j].minRange);
            if ((parseInt(c.value[j].minRange) - parseInt(c.value[i].maxRange)) != 1) {
              c.controls[j].setErrors(rangeMissMatch);
              find = true;
            }
            else {
              find = false;
              c.controls[j].setErrors(null);
            }
            // let isDateRangeOverlaps = this.utilService.dateRangeOverlaps(new Date(c.value[i].startDate.formatted), new Date(c.value[i].endDate.formatted), new Date(c.value[j].startDate.formatted), new Date(c.value[j].endDate.formatted));
            // if (parseInt(c.value[j].minRange) <= parseInt(c.value[i].maxRange)) {
            // c.controls[i].setErrors(rangeMissMatch);
            //   c.controls[j].setErrors(rangeMissMatch);
            //   find = true;
            //   // return datesOverlapped;
            // }
          }
        }
      }
      if (find) {
        return rangeMissMatch;
      }
      return null;
    }
  }


  checkMonthMatch(c: any) {
    const monthMissMatch: any = { monthMissMatch: true };
    let find: boolean = false;
    if (c && c.value && c.value.length) {
      // throw new TypeError('Seasons length must be a greater than 1');    
      c.controls.forEach(x => {
        if (x.errors && x.errors['monthMissMatch']) {
          delete x.errors['monthMissMatch'];
          if ((x.errors === null || typeof (x.errors) === 'undefined') || (x.errors && x.errors.constructor === Object && Object.keys(x.errors).length === 0) ||
            x.errors.toString().trim() === '') {
            x.setErrors(null);
          }
        }
      });
      for (let i = 0; i < c.value.length; i += 1) {
        if (c.value[i].startDate && c.value[i].endDate) {
          // let isDateRangeOverlaps = this.utilService.dateRangeOverlaps(new Date(c.value[i].startDate.formatted), new Date(c.value[i].endDate.formatted), new Date(c.value[j].startDate.formatted), new Date(c.value[j].endDate.formatted));
          if (new Date(c.value[i].startDate).getMonth() != new Date(c.value[i].endDate).getMonth()) {
            c.controls[i].setErrors(monthMissMatch);
            find = true;
            // return datesOverlapped;
          }
        }
      }
      if (find) {
        return monthMissMatch;
      }
      return null;
    }
  }

  checkUniqueMonth(c: any) {
    const monthNotMatch: any = { monthNotMatch: true };
    let find: boolean = false;
    if (c && c.value && c.value.length > 0) {
      // throw new TypeError('Seasons length must be a greater than 1');    
      c.controls.forEach(x => {
        if (x.errors && x.errors['monthNotMatch']) {
          delete x.errors['monthNotMatch'];
          if ((x.errors === null || typeof (x.errors) === 'undefined') || (x.errors && x.errors.constructor === Object && Object.keys(x.errors).length === 0) ||
            x.errors.toString().trim() === '') {
            x.setErrors(null);
          }
        }
      });
      if (c && c.value && c.value.length > 1) {
        for (let i = 0; i < c.value.length - 1; i += 1) {
          for (let j = i + 1; j < c.value.length; j += 1) {
            if (c.value[i].startDate && c.value[i].endDate && c.value[j].startDate && c.value[j].endDate) {
              // let isDateRangeOverlaps = this.utilService.dateRangeOverlaps(new Date(c.value[i].startDate.formatted), new Date(c.value[i].endDate.formatted), new Date(c.value[j].startDate.formatted), new Date(c.value[j].endDate.formatted));
              if (new Date(c.value[i].startDate).getMonth() != new Date(c.value[j].startDate).getMonth()) {
                c.controls[i].setErrors(monthNotMatch);
                c.controls[j].setErrors(monthNotMatch);
                find = true;
                // return datesOverlapped;
              }
            }
          }
        }
      }
      if (find) {
        return monthNotMatch;
      }
      return null;
    }
  }

  checkDateRange(c: any) {
    const dateRangeError: any = { dateRangeError: true };
    let range: boolean = false;
    if (c && c.value && c.value.length) {
      c.controls.forEach(x => {
        if (x.errors && x.errors['dateRangeError']) {
          delete x.errors['dateRangeError'];
          if ((x.errors === null || typeof (x.errors) === 'undefined') || (x.errors && x.errors.constructor === Object && Object.keys(x.errors).length === 0) ||
            x.errors.toString().trim() === '') {
            x.setErrors(null);
          }
        }
      });
      for (let i = 0; i < c.value.length; i++) {
        if (c.value[i].startDate && c.value[i].endDate) {
          if (new Date(c.value[i].endDate) < new Date(c.value[i].startDate)) {
            c.controls[i].setErrors(dateRangeError);
            range = true;
          }
        }
      }
      if (range) {
        return dateRangeError;
      }
    }
    return null;
    // if (c.get('startDate').value && c.get('startDate').value.formatted && c.get('endDate').value && c.get('endDate').value.formatted) {
    //   return { dateRangeError: new Date(c.get('endDate').value.formatted) <= new Date(c.get('startDate').value.formatted) }
    // }
  }

  checkSpecificDateRange(c: any) {
    const dateSpecificRangeError: any = { dateSpecificRangeError: true };
    let range: boolean = false;
    if (c && c.value && c.value.length) {
      c.controls.forEach(x => {
        if (x.errors && x.errors['dateSpecificRangeError']) {
          delete x.errors['dateSpecificRangeError'];
          if ((x.errors === null || typeof (x.errors) === 'undefined') || (x.errors && x.errors.constructor === Object && Object.keys(x.errors).length === 0) ||
            x.errors.toString().trim() === '') {
            x.setErrors(null);
          }
        }
      });
      for (let i = 0; i < c.value.length; i++) {
        if (c.value[i].specificDiscount && c.value[i].specificDiscount.startDate && c.value[i].specificDiscount.endDate) {
          if (new Date(c.value[i].specificDiscount.endDate) < new Date(c.value[i].specificDiscount.startDate)) {
            c.controls[i].setErrors(dateSpecificRangeError);
            range = true;
          }
        }
      }
      if (range) {
        return dateSpecificRangeError;
      }
    }
    return null;
  }

  checkAbtDateRange(c: any) {
    const dateAbtRangeError: any = { dateAbtRangeError: true };
    let range: boolean = false;
    if (c && c.value && c.value.length) {
      c.controls.forEach(x => {
        if (x.errors && x.errors['dateAbtRangeError']) {
          delete x.errors['dateAbtRangeError'];
          if ((x.errors === null || typeof (x.errors) === 'undefined') || (x.errors && x.errors.constructor === Object && Object.keys(x.errors).length === 0) ||
            x.errors.toString().trim() === '') {
            x.setErrors(null);
          }
        }
      });
      for (let i = 0; i < c.value.length; i++) {
        if (c.value[i] && c.value[i].startDate && c.value[i].endDate) {
          if (new Date(c.value[i].endDate) < new Date(c.value[i].startDate)) {
            c.controls[i].setErrors(dateAbtRangeError);
            range = true;
          }
        }
      }
      if (range) {
        return dateAbtRangeError;
      }
    }
    return null;
  }

  abtDateValidatoronKit(c: any) {
    // return (c: FormArray): { [key: string]: boolean } => {
    const abtDatesOverlapped: any = { abtDatesOverlapped: true };
    let find: boolean = false;
    if (c && c.value && c.value.length > 1) {
      // throw new TypeError('Seasons length must be a greater than 1');    
      c.controls.forEach(x => {
        if (x.errors && x.errors['abtDatesOverlapped']) {
          delete x.errors['abtDatesOverlapped'];
          if ((x.errors === null || typeof (x.errors) === 'undefined') || (x.errors && x.errors.constructor === Object && Object.keys(x.errors).length === 0) ||
            x.errors.toString().trim() === '') {
            x.setErrors(null);
          }
        }
      });
      for (let i = 0; i < c.value.length - 1; i += 1) {
        for (let j = i + 1; j < c.value.length; j += 1) {
          if (c.value[i].kitId == c.value[j].kitId) {
            if (c.value[i].startDate && c.value[i].endDate && c.value[j].startDate && c.value[j].endDate) {
              // let isDateRangeOverlaps = this.utilService.dateRangeOverlaps(new Date(c.value[i].startDate), new Date(c.value[i].endDate), new Date(c.value[j].startDate), new Date(c.value[j].endDate));
              let FirstStartDate = new Date(c.value[i].startDate).toString().substr(0,15);
              let FirstEndDate = new Date(c.value[i].endDate).toString().substr(0,15);
              let SecondStartDate = new Date(c.value[j].startDate).toString().substr(0,15);
              let SecondEndDate = new Date(c.value[j].endDate).toString().substr(0,15);
              if (
                new Date(FirstStartDate) <= new Date(SecondStartDate) && new Date(SecondStartDate) <= new Date(FirstEndDate) ||
                new Date(FirstStartDate) <= new Date(SecondEndDate) && new Date(SecondEndDate) <= new Date(FirstEndDate) ||
                new Date(SecondStartDate) < new Date(FirstStartDate) && new Date(FirstEndDate) < new Date(SecondEndDate) ||
                new Date(SecondStartDate) < new Date(FirstEndDate) && new Date(SecondStartDate) > new Date(FirstStartDate)  ||
                new Date(SecondStartDate) === new Date(FirstEndDate)
              ) {
                c.controls[j].setErrors(abtDatesOverlapped);
                find = true;
              }
            }
          }
        }

      }

      if (find) {
        return abtDatesOverlapped;
      }
      return null;
    }
    return null;
  }

  dateValidator(c: any) {
    // return (c: FormArray): { [key: string]: boolean } => {
    const datesOverlapped: any = { datesOverlapped: true };
    let find: boolean = false;
    if (c && c.value && c.value.length > 1) {
      // throw new TypeError('Seasons length must be a greater than 1');    
      c.controls.forEach(x => {
        if (x.errors && x.errors['datesOverlapped']) {
          delete x.errors['datesOverlapped'];
          if ((x.errors === null || typeof (x.errors) === 'undefined') || (x.errors && x.errors.constructor === Object && Object.keys(x.errors).length === 0) ||
            x.errors.toString().trim() === '') {
            x.setErrors(null);
          }
        }
      });
      for (let i = 0; i < c.value.length - 1; i += 1) {
        for (let j = i + 1; j < c.value.length; j += 1) {
          if (c.value[i].startDate && c.value[i].endDate && c.value[j].startDate && c.value[j].endDate) {
            let isDateRangeOverlaps = this.utilService.dateRangeOverlaps(new Date(c.value[i].startDate), new Date(c.value[i].endDate), new Date(c.value[j].startDate), new Date(c.value[j].endDate));
            if (isDateRangeOverlaps) {
              c.controls[i].setErrors(datesOverlapped);
              c.controls[j].setErrors(datesOverlapped);
              find = true;
              // return datesOverlapped;
            }else{
              if(c.controls[j].errors){
                if(Object.keys(c.controls[j].errors).length == 0){
                  c.controls[j].setErrors(null);
                }
              }
            }
          }
        }

      }
      if (find) {
        return datesOverlapped;
      }
      return null;
    }
    return null;
  }


  validateDateRange(c: AbstractControl) {
    if (c.get('startDate').value && c.get('endDate').value) {
      return { 'endDateCrossed': new Date(c.get('endDate').value) <= new Date(c.get('startDate').value) }
    }
  }

  validateDateRanges(c: AbstractControl) {
    if (c.get('activeDate').value && c.get('deactivatedDate').value) {
      return { 'endDateCrossed': new Date(c.get('deactivatedDate').value) <= new Date(c.get('activeDate').value) }
    }
  }

  
  

  validateFee(c: any) {
    const invalidFeeError: any = { invalidFeeError: true };

    c.controls.forEach(x => {

      if (x.controls['fee'].errors && x.controls['fee'].errors['invalidFeeError']){
        delete x.controls['fee'].errors['invalidFeeError'];
        x.controls['fee'].updateValueAndValidity();
      }
      if (x.errors && x.errors['invalidFeeError']) {
        delete x.errors['invalidFeeError'];
        if ((x.errors === null || typeof (x.errors) === 'undefined') || (x.errors && x.errors.constructor === Object && Object.keys(x.errors).length === 0) ||
              x.errors.toString().trim() === '') {
              x.setErrors(null);
            }
         }
       }
    );
    c.controls.forEach(x => {

        if(x.controls['processingFee'].value > x.controls['fee'].value){
          x.controls['fee'].setErrors(invalidFeeError);
          return invalidFeeError;
        } 

        return null;

      }
    );

  }


  dateLessThan(from: string, to: string) {
    return (group: FormGroup): { [key: string]: any } => {
      let f = group.controls[from];
      let t = group.controls[to];
      if (f.value && t.value) {
        if (new Date(f.value) > new Date(t.value)) {
          return {
            //  dates: true
            dates: `End Date should be greater than Start Date`
          };
        }
      }
      return {};
    }
  }

  matchPassword(group: FormGroup) {
    const password = group.controls['password_new'].value;
    const confirmPassword = group.controls['password_confirm'].value;

    if (password !== confirmPassword) {
      //console.log('false');
      return { matchPassword: true };
    }
  }


}



// WEBPACK FOOTER //
// ./src/app/shared/_services/validation.service.ts